import { Injectable } from '@angular/core';
import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { WorkflowTaskChildSummaryModel } from '../workflowTaskChildSummary.model';
import { WorkflowTaskSummaryConverter } from '../../common/converter/workflowTaskSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class WorkflowTaskChildSummaryConverter extends HttpModelConverter<WorkflowTaskChildSummaryModel> {

    constructor(private summaryConverter: WorkflowTaskSummaryConverter) {
        super();
    }

    protected createInstance(): WorkflowTaskChildSummaryModel {
        return new WorkflowTaskChildSummaryModel();
    }

    protected enrichObject(result: WorkflowTaskChildSummaryModel, src: WorkflowTaskChildSummaryModel) {
        result.child = this.summaryConverter.convert(src.child);
    }
}
